

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"viewBox":"0 0 80 80","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","class":[styles && styles["icon__svg"] || "icon__svg",styles && styles["icon__svg--close"] || "icon__svg--close"].join(' '),"fill":"currentColor","width":"80","height":"80"}, rest), [h('undefined', {}, []), h('title', {}, ["Close"]), h('desc', {}, ["Created with Sketch."]), h('g', {"id":"svg-close-2JWtof1","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}, [h('path', {"d":"M39.7999949,31.839996 L71.6399909,7.94919686e-14 L79.5999899,7.95999899 L47.7599939,39.7999949 L80,72.040001 L72.040001,80 L39.7999949,47.7599939 L7.95999899,79.5999899 L1.37845291e-12,71.6399909 L31.839996,39.7999949 L0.400010102,8.36000909 L8.36000909,0.400010102 L39.7999949,31.839996 Z","fill":"currentColor"}, [])])]);
};

        